var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1 20.375H3.90004C3.15004 20.375 2.54004 19.765 2.54004 19.015V5.905H3.81004V19.015C3.81004 19.015 3.85004 19.105 3.90004 19.105H20.1C20.1 19.105 20.19 19.065 20.19 19.015V15.605H21.46V19.015C21.46 19.765 20.85 20.375 20.1 20.375Z",
    fill: "#DEF7F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.45 11.745H20.18V8.27499C20.18 8.27499 20.14 8.18499 20.09 8.18499H17.91V6.91499H20.09C20.84 6.91499 21.45 7.52499 21.45 8.27499V11.745Z",
    fill: "#DEF7F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.55 8.195H4.82004C3.56004 8.195 2.54004 7.175 2.54004 5.915C2.54004 4.655 3.56004 3.625 4.82004 3.625H17.19C17.94 3.625 18.55 4.235 18.55 4.985V8.195ZM4.82004 4.895C4.26004 4.895 3.81004 5.355 3.81004 5.905C3.81004 6.455 4.27004 6.915 4.82004 6.915H17.28V4.975C17.28 4.975 17.24 4.885 17.19 4.885H4.82004V4.895Z",
    fill: "#DEF7F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.45 16.245H16.85C15.43 16.245 14.28 15.095 14.28 13.675C14.28 12.255 15.43 11.105 16.85 11.105H21.45V16.235V16.245ZM16.85 12.375C16.13 12.375 15.55 12.955 15.55 13.675C15.55 14.395 16.13 14.975 16.85 14.975H20.18V12.375H16.85Z",
    fill: "#DEF7F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.2040c3dc3e2a5954d912c1b11020e132.svg";
export { ForwardRef as ReactComponent };